import React from "react";
import { Modal, ModalOverlay, ModalContent, ModalBody, ModalCloseButton, useDisclosure } from "@chakra-ui/react"


const ModalBox = ({ children, closeButton, ...rest }) => {
    // const { onOpen, onClose } = useDisclosure();
    return(
        <Modal {...rest} w="436px" bg="white" borderRadius="16px">
            <ModalOverlay />
            <ModalContent>
                { closeButton && <ModalCloseButton _focus={{boxShadow:"none"}} /> }
                <ModalBody display="flex" flexDir="column" justifyContent="space-between" alignItems="center" p="34px 50px 34px 50px">
                    { children }
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default ModalBox;